import { render } from "./MailCommentsEdit.vue?vue&type=template&id=50580439"
import script from "./MailCommentsEdit.vue?vue&type=script&lang=js"
export * from "./MailCommentsEdit.vue?vue&type=script&lang=js"

import "./MailCommentsEdit.vue?vue&type=style&index=0&id=50580439&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__